import styled from "styled-components";

export const StyledDocumentWrapper = styled.div`
  .document-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;
    &__create-invoice {
      display: inline-grid;
      justify-content:  end;
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
      &__create-invoice { 
        justify-content: start;
    }
  }

  .document-table {
    &__head {
      grid-template-columns: 175px 450px repeat(3, 180px);
    }
    &__row {
      grid-template-columns: 175px 450px repeat(3, 180px);
    }
    &__email {
      max-width: 450px;
      width: 100%;
      overflow-wrap: break-word;
      cursor: pointer;
    }
  }
`;

export const StyledDocumentInvoiceWrapper = styled.div`
  display: inline-grid;
  grid-template-rows: 55px;
  button {
    height: 100%;
  }
`;

export const StyledDocumentDetailsWrapper = styled.div`
  .payout-details-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(155px, max-content));
    grid-gap: 20px;
    .icon-light-reload {
      padding-right: 10px;
      font-weight: 700;
    }
    a, button {
      height: 55px;
    }
  }

  .refiling-details-head {
    padding: 20px 0px;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 576px) {
      flex-direction: column;
    }
  }
`;

export const StyledDocumentDetailsContent = styled.div`
  .payout-details-content {
    &__block {
      grid-template-columns: 20% 80%;
    }
    &__head {
      padding: 0 25px 20px;
    }
    &__row {
      grid-template-columns: repeat(2, 50%);
      & > div {
        padding: 0;
        margin: 0;
        &:before {
          display: none;
        }
        &:last-child {
          display: inline-flex;
          p {
            width: 100%;
            text-align: left;
            overflow-wrap: break-word;
          }
        }
      }
    }
    .errors {
      color: #f44336;
    }
    .icon-light-copy {
      cursor: pointer;
    }
    .service {
      display: grid !important;
      grid-template-columns: 100%;
      grid-template-rows: max-content 55px;
      grid-gap: 10px;
      &__icon {
        border: 1px solid #E5E5E5;
        background-color: #fff;
        border-radius: 5px;
        margin: 0;
        width: 65px;
        height: 55px;
        grid-area: inherit;
      }
    }
    
    @media screen and (max-width: 1920px) {
      max-width:  inherit;
    }
    @media screen and (max-width: 992px) {
      &__block {
        grid-template-columns: 100%;
      }
    }
    @media screen and (max-width: 576px) {
      &__row {
        padding: 15px 0;
        grid-template-columns: 100%;
        & > div:first-child {
          padding-bottom: 10px;
          color: #162954;
          font-weight: 600;
        }
      }
    }
  }
`;